import React from 'react';

/**
 * Confirm what an employee Excel import will create / change before writing.
 */
export default function EmployeeImportConfirmModal({
  open,
  preview,
  fileName,
  applying,
  onCancel,
  onConfirm,
}) {
  if (!open || !preview) return null;
  const { created = [], updated = [], unchanged = [] } = preview;
  const canImport = created.length + updated.length > 0;

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      onClick={applying ? undefined : onCancel}
    >
      <div
        style={{ background: '#fff', borderRadius: 10, width: 'min(820px, 94vw)', maxHeight: '86vh', display: 'flex', flexDirection: 'column' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ padding: '14px 16px', borderBottom: '1px solid #e5e7eb' }}>
          <h3 style={{ margin: 0, color: '#1e3a5f', fontSize: 16 }}>Review import before applying</h3>
          <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>
            {fileName || 'Excel file'} — nothing is saved until you click Import.
          </div>
        </div>
        <div style={{ padding: '12px 16px', overflow: 'auto', fontSize: 13 }}>
          <div style={{ display: 'flex', gap: 12, marginBottom: 12, flexWrap: 'wrap' }}>
            <StatChip label="New" value={created.length} color="#047857" />
            <StatChip label="Modified" value={updated.length} color="#b45309" />
            <StatChip label="Unchanged" value={unchanged.length} color="#6b7280" />
          </div>

          {created.length > 0 && (
            <Section title="New employees">
              {created.slice(0, 40).map((r) => (
                <div key={`c-${r.emp_code}`} style={{ padding: '4px 0', borderBottom: '1px solid #f3f4f6' }}>
                  <strong>{r.emp_code}</strong> {r.emp_name || `${r.last_name}, ${r.first_name}`}
                  {r.empl_email ? <span style={{ color: '#6b7280' }}> · {r.empl_email}</span> : null}
                  {r.status && r.status !== 'active' ? <span> · {r.status}</span> : null}
                </div>
              ))}
              {created.length > 40 ? <div style={{ color: '#6b7280', marginTop: 6 }}>…and {created.length - 40} more</div> : null}
            </Section>
          )}

          {updated.length > 0 && (
            <Section title="Existing employees that will change">
              {updated.slice(0, 40).map((r) => (
                <div key={`u-${r.emp_code}`} style={{ padding: '6px 0', borderBottom: '1px solid #f3f4f6' }}>
                  <strong>{r.emp_code}</strong> {r.emp_name || `${r.last_name}, ${r.first_name}`}
                  {(r.changes || []).map((c) => (
                    <div key={c.field} style={{ marginLeft: 12, color: '#374151' }}>
                      {c.field}: <span style={{ color: '#b91c1c' }}>{c.from}</span>
                      {' → '}
                      <span style={{ color: '#047857' }}>{c.to}</span>
                    </div>
                  ))}
                </div>
              ))}
              {updated.length > 40 ? <div style={{ color: '#6b7280', marginTop: 6 }}>…and {updated.length - 40} more</div> : null}
            </Section>
          )}

          {!canImport && (
            <div style={{ color: '#6b7280' }}>Every row already matches the master list. Nothing to import.</div>
          )}
        </div>
        <div style={{ padding: '12px 16px', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button type="button" onClick={onCancel} disabled={applying} style={btn('white', '#374151', '#d1d5db')}>Cancel</button>
          <button type="button" onClick={onConfirm} disabled={applying || !canImport} style={btn('#1e3a5f', '#fff', '#1e3a5f')}>
            {applying ? 'Importing…' : `Import ${created.length + updated.length} change(s)`}
          </button>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ fontWeight: 700, color: '#1e3a5f', marginBottom: 4 }}>{title}</div>
      {children}
    </div>
  );
}

function StatChip({ label, value, color }) {
  return (
    <div style={{ border: `1px solid ${color}`, color, borderRadius: 8, padding: '6px 10px', minWidth: 88 }}>
      <div style={{ fontSize: 18, fontWeight: 700 }}>{value}</div>
      <div style={{ fontSize: 11 }}>{label}</div>
    </div>
  );
}

function btn(bg, color, border) {
  return {
    padding: '8px 14px',
    borderRadius: 6,
    border: `1px solid ${border}`,
    background: bg,
    color,
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: 13,
  };
}
